import React, {useRef, useState, useEffect} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {CSS_CONSTANTS} from '../../css_variables';

const Wrapper = styled.div`
	position: relative;
`;

const Tooltip = styled.div`
	position: absolute;
	padding: 10px 16px;
	background-color: ${CSS_CONSTANTS.v2_tooltip_grey};
	border: 1px solid ${CSS_CONSTANTS.v2_grey};
	border-radius: 5px;
	left: ${props => (props.position ? props.position.left + 'px' : '-1000px')};
	top: ${props => (props.position ? props.position.top + 'px' : '-1000px')};
	box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.05);

	//text
	font-size: 11px;
	color: ${CSS_CONSTANTS.v2_text_gray};
	font-weight: 500;

	cursor: pointer;
	z-index: 9;
`;

const TriangleWrapper = styled.div`
	position: absolute;
	left: ${props => (props.position ? props.position.left + 'px' : null)};
	top: ${props => (props.position ? props.position.top + 'px' : null)};
`;

const Triangle = () => (
	<svg width="30" height="13" viewBox="0 0 87 38" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M8.8404 27.1077L43.5 1.24767L78.1596 27.1077H8.8404Z" fill="#EBEBEB" stroke="#CBCBCB" strokeWidth="2" />
		<path fillRule="evenodd" clipRule="evenodd" d="M75.2611 26.1077L77.69 28.1077H9.42L11.8489 26.1077H75.2611Z" />
		<path
			d="M75.2611 26.1077L76.5324 24.5638L75.9786 24.1077H75.2611V26.1077ZM77.69 28.1077V30.1077H83.2652L78.9613 26.5638L77.69 28.1077ZM9.42 28.1077L8.14868 26.5638L3.84479 30.1077H9.42V28.1077ZM11.8489 26.1077V24.1077H11.1314L10.5775 24.5638L11.8489 26.1077ZM73.9898 27.6516L76.4187 29.6516L78.9613 26.5638L76.5324 24.5638L73.9898 27.6516ZM77.69 26.1077H9.42V30.1077H77.69V26.1077ZM10.6913 29.6516L13.1202 27.6516L10.5775 24.5638L8.14868 26.5638L10.6913 29.6516ZM11.8489 28.1077H75.2611V24.1077H11.8489V28.1077Z"
			fill="#EBEBEB"
		/>
	</svg>
);

export const TooltipContainer = ({children, text}) => {
	// Not the prettiest solution, but it's better than having to conditionally render the entire wrapper if the tooltip is conditional
	if (text === null) return <>{children}</>;
	const childrenWrapperRef = useRef(null);
	const tooltipRef = useRef(null);

	const [tootltipPosition, setTootltipPosition] = useState(null);
	const [arrowPosition, setArrowPosition] = useState(null);
	const [tooltipVisible, setTooltipVisible] = useState(false);

	const positionTootltip = () => {
		const iconBoundingRect = childrenWrapperRef.current.getBoundingClientRect();
		const tooltipSize = tooltipRef.current.getBoundingClientRect();
		const position = {top: null, bottom: null, left: null, right: null, oneRowTooltip: false};
		position.left = (iconBoundingRect.width - tooltipSize.width) / 2;

		let positionTootltip = {
			top: -9,
			left: tooltipSize.width / 2 - 15,
		};

		setTootltipPosition(position);
		setArrowPosition(positionTootltip);
	};

	useEffect(() => {
		if (tooltipVisible) {
			positionTootltip();
		}
	}, [tooltipVisible]);

	const handleMouseEnter = () => {
		setTooltipVisible(true);
	};
	const handleMouseLeave = () => {
		setTooltipVisible(false);
	};

	return (
		<Wrapper
			className={'tooltip-container'}
			ref={childrenWrapperRef}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{children}
			{tooltipVisible ? (
				<Tooltip ref={tooltipRef} position={tootltipPosition}>
					<TriangleWrapper position={arrowPosition}>
						<Triangle></Triangle>
					</TriangleWrapper>

					{text}
				</Tooltip>
			) : null}
		</Wrapper>
	);
};

TooltipContainer.propTypes = {
	text: PropTypes.string,
	cy: PropTypes.string,
	children: PropTypes.any.isRequired,
};
